import type { Address } from '~~/types/commercetools';

import { CheckoutClientType } from '~~/types/checkout/formData/checkoutClientType';
import type { AddressType } from '~~/types/AddressType';
import { getClientTypeFromAddress } from '~~/helpers/Checkout/getClientTypeFromAddress';

const useCheckoutClientType = (step: AddressType) => {

  const clientType = useState<CheckoutClientType | null>(`useCheckoutClientType-${step}`, () => null);
  const isCompany = computed(() => clientType.value === CheckoutClientType.COMPANY);
  const isClientTypeSelected = computed(() => Boolean(clientType.value));
  const setClientType = async (value: CheckoutClientType) => {

    clientType.value = value;
  
  };
  const setClientTypeFromAddress = async (address: Maybe<Partial<Address>>) => {

    const clientType = getClientTypeFromAddress(address);

    if (clientType) {

      await setClientType(clientType);

    }
  
  };

  return {
    clientType,
    isCompany,
    isClientTypeSelected,
    setClientType,
    setClientTypeFromAddress,
  };

};
export default useCheckoutClientType;
